import { render, staticRenderFns } from "./chosenRolSupervisor.vue?vue&type=template&id=39f40942&scoped=true&"
import script from "./chosenRolSupervisor.vue?vue&type=script&lang=js&"
export * from "./chosenRolSupervisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f40942",
  null
  
)

export default component.exports